import { render, staticRenderFns } from "./designation.vue?vue&type=template&id=4c5d35c0&scoped=true"
import script from "./designation.vue?vue&type=script&lang=js"
export * from "./designation.vue?vue&type=script&lang=js"
import style0 from "./designation.vue?vue&type=style&index=0&id=4c5d35c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d35c0",
  null
  
)

export default component.exports